export default __webpack_public_path__ + "b212e1ac5959caa3252bd9c75c27caf2.svg";